import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';

const STORIES = [
  {
    title: 'Start small, look sharp',
    body: (
      <>
        Birthdays, showers, and pop-ups — book a booth or DJ without the agency
        runaround. Hosts on VendaList make{' '}
        <span className="font-medium text-white">weekend events</span> feel
        polished.
      </>
    ),
    image: '/images/01_-_HERO_1.webp',
    href: '/browse-vendors',
  },
  {
    title: 'Plan the day that matters',
    body: (
      <>
        Weddings and milestones with verified crews, clear packages, and dates
        you can lock. From one vendor to a full{' '}
        <span className="font-medium text-white">event crew</span>.
      </>
    ),
    image: '/images/02_-_HERO.webp',
    href: '/how-it-works',
  },
  {
    title: 'Run events that scale',
    body: (
      <>
        Brand activations and corporate gatherings — the same calm book flow,
        bigger production. Teams use VendaList like{' '}
        <span className="font-medium text-white">ops for the party</span>.
      </>
    ),
    image:
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1200&q=80',
    href: '/browse-vendors',
  },
];

/**
 * Shopify-style night band: thin headline + 3 photo story cards + ghost CTA.
 */
const MarketingAudienceBand = () => {
  return (
    <section className="bg-m-night px-4 py-20 text-m-on-dark sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto w-full max-w-6xl">
        <h2 className="marketing-section-title mb-12 max-w-3xl text-m-on-dark sm:mb-16">
          For parties from backyard to ballroom
        </h2>

        <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-6 lg:gap-8">
          {STORIES.map((story) => (
            <article key={story.title} className="flex flex-col">
              <Link
                to={story.href}
                className="group relative mb-5 block overflow-hidden rounded-2xl"
              >
                <img
                  src={story.image}
                  alt=""
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                  loading="lazy"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/35 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              </Link>
              <h3 className="mb-2 text-lg font-medium tracking-tight text-m-on-dark">
                {story.title}
              </h3>
              <p className="marketing-body text-white/65">{story.body}</p>
            </article>
          ))}
        </div>

        <div className="mt-14 flex justify-center sm:mt-16">
          <Link to="/browse-vendors" className="marketing-btn marketing-btn-ghost gap-2">
            Start browsing
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingAudienceBand;
